<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.px-5.accent
        v-row(no-gutters align="center")
          v-col
            p.mb-0.title.white--text Products
          v-col.shrink
            v-btn.mr-n2(text icon @click="showModal = !showModal" height)
              v-icon(color="white" :size="24") mdi-close

      v-card-text.pa-0.text-center
        div.text-center.my-2
          div.caption Total Amount
          div.display-1.font-weight-bold {{ totalPrice | displayPrice }}

        v-card.ma-2(outlined)
          v-simple-table.mb-2.text-left
            thead
              tr
                th.px-1.text-center.basic400(style="width: 10%") No
                th.px-1.basic400 Item
                th.px-1.basic400(style="width: 15%") Qty
                th.px-1.basic400 Total price

            tbody
              tr(v-for="(item, index) in filter_products" :key="item.id")
                td.px-1.text-center
                  p.mb-0.caption {{ index + 1 }}
                td.px-1
                  div
                    p.mb-0.caption {{ item.name || item.product.name }}
                    template(v-if="item.addons" v-for="addon in item.addons")
                      p.mb-0.caption.grey--text.text--darken-1(style="font-size: 12px !important") - {{ addon.name || item.product.name }} ( x {{ addon.quantity_per_set }} )
                td.px-1
                  div
                    p.mb-0.caption x {{ item.quantity }}
                td.px-1
                  p.mb-0.caption {{ product_price(item) | displayPrice }}

      v-card-actions
        v-spacer
        v-btn(color='grey', text='', @click='showModal = false' :disabled="loading")
          | Close

</template>

<script>
export default {
  name: 'CatalogItemsDialog',
  props: ['open', 'products'],
  data: () => ({
    loading: false,
    filter_products: []
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    totalPrice() {
      let total = 0
      this.products.forEach(o => {
        if (o.variant_products) {
          o.variant_products.forEach(r => {
            total += (r.price * r.quantity)
          })
        } else if (o.addon_products) {
          o.addon_products.forEach(r => {
            r.addons.forEach(c => {
              total += ((r.price + (c.price + c.quantity_per_set)) * r.quantity)
            })
          })
        } else {
          total += (o.price * o.quantity)
        }
      })
      return total
    },
  },
  watch: {
    showModal: {
      immediate: true,
      handler (val) {
        if (val) {
          this.filter_products = [...this.products.filter(f => f.quantity > 0)]
        }
      }
    }
  },
  methods: {
    product_price (prod) {
      let total = 0
      if (prod.variant_products) {
        prod.variant_products.forEach(r => {
          total += (r.price * r.quantity)
        })
      } else if (prod.addon_products) {
        prod.addon_products.forEach(r => {
          r.addons.forEach(c => {
            total += ((r.price + (c.price + c.quantity_per_set)) * r.quantity)
          })
        })
      } else {
        total += (prod.price * prod.quantity)
      }
      return total
    }
  }
}
</script>

<style scoped>
</style>
